import type { PatentBasicEntity } from '../types';

export const PATENT_VALUATION_LEVELS = [
    {
        min: 0,
        max: 10000,
        level: 0.5,
    },
    {
        min: 10000,
        max: 25000,
        level: 1,
    },
    {
        min: 25000,
        max: 50000,
        level: 1.5,
    },
    {
        min: 50000,
        max: 100000,
        level: 2,
    },
    {
        min: 100000,
        max: 200000,
        level: 2.5,
    },
    {
        min: 200000,
        max: 500000,
        level: 3,
    },
    {
        min: 500000,
        max: 1000000,
        level: 3.5,
    },
    {
        min: 1000000,
        max: 2500000,
        level: 4,
    },
    {
        min: 2500000,
        max: 5000000,
        level: 4.5,
    },
    {
        min: 5000000,
        max: Infinity,
        level: 5,
    },
];

export const OVER_VIEW_LIMIT_ERROR_MESSAGE = 'over view limit';

export const DEFAULT_PATENT_BASIC_DATA: PatentBasicEntity = {
    ABST: {},
    ABST_LANG: '',
    AE: {},
    AN: {},
    ANC: {},
    ANCS_ID_MAPPING: {},
    ANC_ADD: {},
    AN_ADD: {},
    APD: '',
    APN: '',
    AT: {},
    ATC: {},
    ATC_C: {},
    AT_C: {},
    AWARD: '',
    COUNTRY: '',
    AI_TECHNICAL_BENEFIT: '',
    FAMILY_ID: '',
    GOV: {},
    IMAGE_ID: '',
    IN: {},
    INC: {},
    ISD: '',
    LANG_DEFAULT: '',
    ORIGINAL_PN: {},
    PATENT_ID: '',
    PATENT_TYPE: '',
    PBD: '',
    PE: {},
    PN: '',
    RELATED_PATENT: {},
    TITLE: {},
    TITLE_LANG: '',
    can_alert_file_wrapper: false,
    errata_deleted: false,
    high_value_patent: false,
    stemming: false,
    total_figure: 0,
    linksFiltered: [],
    isNoValuation: false,
    valuation: '',
    transferHistory: [],
    JPDC_DTERM: {},
    HAS_CUSTOMS: false,
    HAS_FILE_WRAPPER: false,
    HAS_LICENSE: false,
    HAS_LITIGATION: false,
    HAS_PLEDGE: false,
    HAS_REFERENCE: false,
    HAS_REREXAM: false,
    HAS_STANDARD: false,
};
